import React, { useCallback, useEffect, useState } from "react";
import { Steps } from "antd";
import HeaderDashboard from "../../../components/layout/header/HeaderDashboard";
import Step1 from "./Identity";
import Step4 from "./Agreement";
import { FaShieldAlt, FaFileAlt } from "react-icons/fa";
import CircleLoader from "../../../components/common/CircleLoader";
import { Provider } from "../../../components/MultiStepForm/MultiStepFormContext";
import "../tcGuaranteeStep.scss";
import { getCheckTokenValidityUrl } from "../../../utils/constants/apiEndPoints";
import publicAxios from "../../../utils/publicAxios";
import { showToast } from "../../../utils/utils";
import { showToastType } from "../../../utils/constants/appConstants";
import { useSearchParams } from "react-router-dom";
import { identityText } from "../../../locales/en";

const { Step } = Steps;

const renderStep = (step) => {
  switch (step) {
    case 0:
      return <Step1 />;
    case 1:
      return <Step4 />;
    default:
      return <Step1 />;
  }
};

const TcGuarnteeClient = () => {
  const [getToken, setToken] = useState("");
  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState(0);
  const [stepValue, setStepValue] = useState(0);
  const [isExpired, setIsExpired] = useState(null);
  const [loading, setLoading] = useState(true);

  const CheckTokenValidity = useCallback(async () => {
    try {
      setLoading(true);
      const response = await publicAxios.get(getCheckTokenValidityUrl, {
        params: { token: getToken }
      });

      if (response.status === 200) {
        setIsExpired(response.data.data.isUsed);
      }
    } catch (error) {
      showToast(error.response?.data?.message, showToastType.error);
    } finally {
      setLoading(false);
    }
  }, [getToken]);

  const next = () => {
    const nextStep = currentStep + 1;
    if (nextStep > stepValue) {
      setStepValue(nextStep);
    }
    setCurrentStep(nextStep);
  };
  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  useEffect(() => {
    const token = searchParams.get("token");
    setToken(token);
  }, [searchParams]);

  useEffect(() => {
    if (getToken) {
      CheckTokenValidity();
    }
  }, [getToken]);

  if (loading) {
    return <CircleLoader />;
  }

  return (
    <div className="steplist-wrap guarantee-wrap">
      <HeaderDashboard />

      <div className="container">
        {isExpired === false ? (
          <div className="row">
            <Provider value={{ next, prev }}>
              <div className="stepContainer">
                <Steps
                  current={currentStep}
                  onChange={(step) => {
                    if (step <= stepValue) {
                      setCurrentStep(step);
                    }
                  }}
                  className={currentStep === 1 ? "custom-step-active" : ""}
                >
                  <Step
                    title={"Step 1: Verify Your Identity"}
                    icon={<FaShieldAlt />}
                  />
                  <Step title={"Step 4: Agreement"} icon={<FaFileAlt />} />
                </Steps>
              </div>
              <main>{renderStep(currentStep)}</main>
            </Provider>
          </div>
        ) : (
          <div className="row">
            <div className="col-12">
              <div className="expired-token-message text-center pt-5">
                <h3>{identityText?.tokenExpiredText}</h3>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default TcGuarnteeClient;
